import { BaseEntity, GroupEntity, PaginatedEntity, UserEntity } from '@core/entities/index';
import { Expose, Transform, Type } from 'class-transformer';
import { SafeUrl } from '@angular/platform-browser';

export class NewsList extends PaginatedEntity {
  @Type(() => NewsEntity)
  news: NewsEntity[];
}

export class GroupNewsList extends PaginatedEntity {
  @Type(() => GroupNewsEntity)
  groupNews: GroupNewsEntity[];
}

export class NewsEntity extends BaseEntity<NewsEntity> {
  title = '';

  @Expose()
  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  headline = '';

  @Expose()
  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  text = '';

  author = 0;
  priority = 1;
  type: string;

  @Expose({ name: 'publication_date_from' })
  publicationDateFrom = new Date().toISOString();

  @Expose({ name: 'publication_date_to' })
  publicationDateTo = new Date().toISOString();

  attachment: string | null;
  tags = '';
  @Expose({ name: 'news_tags' })
  @Type(() => NewsTag)
  newsTags: { tagId: any; tagName: any }[] = [];

  audience = '1';
  guests: number;

  @Expose({ name: 'show_guest_list' })
  showGuestList = false;

  @Expose({ name: 'is_highlighted' })
  isHighlighted = false;

  @Expose({ name: 'update_image_url' })
  updateImageUrl: any | null;

  @Expose({ name: 'is_image_converted' })
  isImageConverted: number;

  @Type(() => UserEntity)
  user: UserEntity;

  @Type(() => GroupEntity)
  // @Transform(({ value }) => value[0])
  groups: GroupEntity[] | number[] = [];

  imageUrls = '';
  newImage = ''; // property for new image in update news record

  // For Ui use only
  imageUrl: string | SafeUrl = null;
  // For  put post
  highlighted = false;

  constructor(values?: Partial<NewsEntity>) {
    super();
    this.initEntity(values);
  }
}

export class NewsTag {
  @Expose({ name: 'news_id' })
  newsId: number;
  id: number;

  @Expose({ name: 'tag_id' })
  tagId: number;

  @Expose({ name: 'tag_name' })
  tagName: string;
}

export class NewsImage {
  @Expose({ name: 'news_id' })
  newsId: number;
  @Expose({ name: 'news_image' })
  newsImage: string;
}

export class GroupNewsEntity {
  @Type(() => GroupEntity)
  group: GroupEntity;

  @Type(() => NewsEntity)
  news: NewsEntity;
}
